import { DevTools, FormatSimple, Tolgee } from '@tolgee/web';
import { sharedConfig } from '@/config/sharedConfig';
import { FormatIcu } from '@tolgee/format-icu';
import type { TolgeeStaticData } from '@tolgee/react';

export const ALL_LOCALES = ['en', 'de-DE', 'zh-Hans'];

export const DEFAULT_LOCALE = sharedConfig.defaultLocale;

const apiKey = process.env.NEXT_PUBLIC_TOLGEE_API_KEY;
const apiUrl = sharedConfig.tolgeeApi;

export async function getStaticData(languages: string[]): Promise<TolgeeStaticData> {
  const result: TolgeeStaticData = {};
  for (const lang of languages) {
    result[lang] = (await import(`../i18n/${lang}.json`)).default;
  }
  return result;
}

export function TolgeeBase() {
  return Tolgee().use(FormatSimple()).use(FormatIcu()).use(DevTools()).updateDefaults({
    apiKey,
    apiUrl,
    defaultLanguage: DEFAULT_LOCALE,
    availableLanguages: ALL_LOCALES,
  });
}
